import { useStaticQuery, graphql } from 'gatsby';

export const useHomepagePromo1Data = () => {
  const { taxonomyTermPromotion } = useStaticQuery(
    graphql`
      query HomepagePromo1Data {
        taxonomyTermPromotion(drupal_internal__tid: { eq: 140 }) {
          relationships {
            field_promoted_content {
              ... on node__event {
                id
                title
                body {
                  summary
                }
                srcSet: field_image {
                  ...eventSrcSet16x9Fragment
                  ...eventSrcSet10x7Fragment
                }
                field_image {
                  imageDerivatives {
                    links {
                      w344_16_9 {
                        href
                      }
                    }
                  }
                  alt
                }
                relationships {
                  type: node_type {
                    name
                  }
                  field_tags {
                    relationships {
                      parent {
                        name
                      }
                    }
                  }
                }
                path {
                  alias
                }
              }
              ... on node__news {
                id
                title
                body {
                  summary
                }
                srcSet: field_image {
                  ...newsSrcSet16x9Fragment
                  ...newsSrcSet10x7Fragment
                }
                field_image {
                  imageDerivatives {
                    links {
                      w344_16_9 {
                        href
                      }
                    }
                  }
                  alt
                }
                relationships {
                  type: node_type {
                    name
                  }
                  field_tags {
                    relationships {
                      parent {
                        name
                      }
                    }
                  }
                }
                path {
                  alias
                }
              }
              ... on node__page {
                id
                title
                body {
                  summary
                }
                srcSet: field_image {
                  ...pageSrcSet16x9Fragment
                  ...pageSrcSet10x7Fragment
                }
                field_image {
                  imageDerivatives {
                    links {
                      w344_16_9 {
                        href
                      }
                    }
                  }
                  alt
                }
                relationships {
                  type: node_type {
                    name
                  }
                  field_tags {
                    relationships {
                      parent {
                        name
                      }
                    }
                  }
                }
                path {
                  alias
                }
              }
              ... on node__place {
                id
                title
                body {
                  summary
                }
                srcSet: field_image {
                  ...placeSrcSet16x9Fragment
                  ...placeSrcSet10x7Fragment
                }
                field_image {
                  imageDerivatives {
                    links {
                      w344_16_9 {
                        href
                      }
                    }
                  }
                  alt
                }
                relationships {
                  type: node_type {
                    name
                  }
                  field_tags {
                    relationships {
                      parent {
                        name
                      }
                    }
                  }
                }
                path {
                  alias
                }
              }
            }
          }
        }
      }
    `
  );

  // Clean up the field mapping so it's easier to reference them
  // in the component.
  let promo1query =
    taxonomyTermPromotion.relationships.field_promoted_content[0];

  const ratio16x9links = promo1query?.srcSet?.ratio16x9?.links ?? {};
  const ratio16x9 = ratio16x9links
    ? Object.keys(ratio16x9links).map((value) => ratio16x9links[value].href)
    : [];

  const homepagePromo1Data = {
    title: promo1query?.title,
    id: promo1query?.id,
    summary: promo1query?.body?.summary,
    url: promo1query?.path?.alias,
    type: promo1query?.relationships?.type?.name,
    parentTag:
      promo1query?.relationships?.field_tags[0]?.relationships?.parent[0]?.name,
    tag: promo1query?.relationships?.field_tags[0]?.name,
    srcSet: {
      alt: promo1query?.field_image?.alt,
      srcs: {
        ratio16x9
      }
    },
    largeImage: {
      alt: promo1query?.field_image?.alt,
      // eslint-disable-next-line camelcase
      src: promo1query?.field_image?.imageDerivatives?.links?.w344_16_9?.href
    },
    image: {
      alt: promo1query?.field_image?.alt,
      // eslint-disable-next-line camelcase
      src: promo1query?.field_image?.imageDerivatives?.links?.w344_16_9?.href
    }
  };

  return homepagePromo1Data;
};
